var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-text",class:`status-${_vm.status}`},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"action"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-indicator"},[_c('div',{staticClass:"dot"}),_vm._v(" "),_c('div',{staticClass:"line"})])
}]

export { render, staticRenderFns }